import { useState, useRef, useEffect } from "react"
import {
    PROJECT_COUNTRY,
    PROJECT_LANGUAGE
  } from "../../../core/APIUtils"
import { loadGoogleMaps } from "../../bundle/utils";
export const AutocompleteAddress = (props: any) => {
    const {handleSelect, addressType} = props
    const containerRef = useRef<HTMLDivElement>(null);
    const [placeJson, setPlaceJson] = useState<any>(null);
    let autocompleteZone = PROJECT_COUNTRY.toLowerCase()

    useEffect(() => {
        let autocompleteEl: google.maps.places.PlaceAutocompleteElement;
        let cancelled = false;
    
        async function init() {
            try {
                const google = await loadGoogleMaps();
    
                if (cancelled || !containerRef.current) {
                    return;
                }
    
                await google.maps.importLibrary("places");
    
                if (cancelled || !containerRef.current) {
                    return;
                }
    
                autocompleteEl = new google.maps.places.PlaceAutocompleteElement({});
                autocompleteEl.includedRegionCodes = [autocompleteZone];
                autocompleteEl.requestedLanguage = PROJECT_LANGUAGE;
                autocompleteEl.name = addressType;
    
                autocompleteEl.style.setProperty("color-scheme", "only light");
                autocompleteEl.style.setProperty("font-family", "Mulish");
                autocompleteEl.style.setProperty("font-size", "1rem");
    
                containerRef.current.appendChild(autocompleteEl);
    
                // @ts-ignore – Google event typing is incomplete
                autocompleteEl.addEventListener(
                    "gmp-select",
                    async (placePrediction: google.maps.places.PlacePrediction) => {
                        const place = placePrediction.placePrediction.toPlace();
    
                        await place.fetchFields({
                            fields: ["addressComponents"],
                        });
    
                        if (cancelled) {
                            return;
                        }
    
                        setPlaceJson(place.toJSON());
                        handleSelect(place);
                    }
                );
            } catch (error) {
                console.error(
                    "Errore inizializzazione Google Places:",
                    error
                );
            }
        }
    
        init();
    
        return () => {
            cancelled = true;
            autocompleteEl?.remove();
        };
    }, [autocompleteZone, addressType, PROJECT_LANGUAGE]);

    return (
        <div>
            <div ref={containerRef} />
            {placeJson && (
                <>
                    <p>Selected Place:</p>
                    <pre>{JSON.stringify(placeJson, null, 2)}</pre>
                </>
            )}
        </div>
    )
}